import Vue from 'vue'

import LandingContact from './components/landing/Contact'

const app = new Vue({
    el: '#app',
    components: {
        "landing-contact": LandingContact
    }
});
